import { SSOConnection } from '../../../api/sso';
import { formatDateLocalized } from '../../../utils/localeUtils';

export class SSOConnectionUtils {
  public static filterActiveConnections(connections: SSOConnection[]): SSOConnection[] {
    return connections.filter(c => c.status === 'ACTIVE');
  }

  public static filterDisabledConnections(connections: SSOConnection[]): SSOConnection[] {
    return connections.filter(c => c.status === 'DISABLED');
  }

  public static hasActiveConnection(connections: SSOConnection[]): boolean {
    return connections.some(c => c.status === 'ACTIVE');
  }

  public static hasDisabledConnection(connections: SSOConnection[]): boolean {
    return connections.some(c => c.status === 'DISABLED');
  }

  public static isConnectionActive(connection: SSOConnection): boolean {
    return connection.status === 'ACTIVE';
  }

  public static formatCreatedDate(dateString: string): string {
    return formatDateLocalized(dateString, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}
